const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://1kufcz1sb7.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://k3zxqskfy4.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.newmont.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.newmont.forwoodsafety.com',
    WEBSOCKET: 'wss://60brha8aij.execute-api.us-west-2.amazonaws.com/prod'
  },
};

export default config;